import type { SVGProps } from 'react'
const SvgSecureFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.09961 6.44434V11.1006C6.09969 13.097 6.66051 14.9109 7.78223 16.5439C8.8976 18.1677 10.3038 19.2492 12 19.7949C13.6962 19.2492 15.1024 18.1687 16.2178 16.5449C17.3395 14.9118 17.9003 13.098 17.9004 11.1016V6.44434L12 4.25195L6.09961 6.44434ZM19.0996 11.1006C19.0995 13.4238 18.429 15.5146 17.0879 17.3691C15.7475 19.2226 14.0604 20.4538 12.0283 21.0586L12 21.0674L11.9717 21.0586C9.93953 20.4552 8.25255 19.2246 6.91211 17.3711C5.57098 15.5165 4.90047 13.4251 4.90039 11.1006V5.62305L4.96484 5.59863L11.9648 2.9834L12 2.9707L12.0352 2.9834L19.0352 5.59863L19.0996 5.62305V11.1006Z"
      fill="#66AF57"
      stroke="#66AF57"
      strokeWidth="0.2"
    />
    <path
      d="M10.0158 10.7322C9.96063 10.6753 9.8951 10.6301 9.82294 10.5993C9.75078 10.5684 9.6734 10.5526 9.59525 10.5526C9.51711 10.5526 9.43973 10.5684 9.36757 10.5993C9.2954 10.6301 9.22987 10.6753 9.17474 10.7322C9.11936 10.7889 9.07541 10.8563 9.04542 10.9304C9.01544 11.0046 9 11.0842 9 11.1645C9 11.2449 9.01544 11.3244 9.04542 11.3986C9.07541 11.4728 9.11936 11.5401 9.17474 11.5968L11.3128 13.7949L11.3475 13.8306C11.3997 13.8843 11.4616 13.9269 11.5298 13.956C11.598 13.985 11.6711 14 11.7449 14C11.8187 14 11.8918 13.985 11.96 13.956C12.0282 13.9269 12.0901 13.8843 12.1423 13.8306L15.8352 10.0341C15.8874 9.98045 15.9289 9.91677 15.9572 9.84667C15.9854 9.77657 16 9.70142 16 9.62553C16 9.54964 15.9854 9.47449 15.9572 9.40439C15.9289 9.33429 15.8874 9.27062 15.8352 9.217L15.7889 9.16944C15.7368 9.11573 15.6748 9.07312 15.6066 9.04404C15.5385 9.01497 15.4654 9 15.3915 9C15.3177 9 15.2446 9.01497 15.1764 9.04404C15.1082 9.07312 15.0463 9.11573 14.9942 9.16944L11.7441 12.509L10.0158 10.7322Z"
      fill="#66AF57"
    />
  </svg>
)

export default SvgSecureFile
